export default {
  toolbar: {
    minHeight: '6.8rem',
    alignItems: 'center',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    actionsSection: {
      alignItems: 'center',
      display: 'flex',
    },
  },
}
